/**
 * When map strokes are authored in screen pixels, a zoom change invalidates them.
 * Rebuilding on every notch, and again when the camera merely stops, is the hitch.
 * Restroke only once the zoom has left the 8% band around the last painted zoom.
 *
 * Phaser-free so play and the editor share one policy and unit tests can cover it.
 */

/**
 * How far the camera zoom may drift from the zoom the map layers were stroked for
 * before they are rebuilt. A 1 px stroke landing anywhere between about 0.93 px and
 * 1.08 px stays as it was painted, including after the camera holds still.
 */
export const MAP_LAYER_ZOOM_TOLERANCE = 1.08;

export type ZoomChromeDecision = 'restroke' | 'defer';

export function noteZoom(
  drawnZoom: number,
  nextZoom: number,
  tolerance = MAP_LAYER_ZOOM_TOLERANCE,
): ZoomChromeDecision {
  if (!(drawnZoom > 0) || !(nextZoom > 0) || !(tolerance > 1)) {
    return 'restroke';
  }

  const drift = nextZoom / drawnZoom;

  if (drift > tolerance || drift < 1 / tolerance) {
    return 'restroke';
  }

  return 'defer';
}
